import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import * as S from './Footer.styled';

const Offices = () => {
  const { t } = useTranslation(['footer'], { useSuspense: false });
  return (
    <S.ContactBlock>
      <S.FooterItemsTitle>{t('Offices')}</S.FooterItemsTitle>
      <S.FooterItems>
        <S.Subtitle1>{t('HeadquarterBarcelona')}</S.Subtitle1>
        <div>
          C/ Pere IV, 128
          <br />
          08005, Barcelona
        </div>
        <a id="telBCN" href="tel:932206741">
          932 20 67 41
        </a>
      </S.FooterItems>
      <S.FooterItems>
        <S.Subtitle1>{t('HeadquarterMadrid')}</S.Subtitle1>
        <div>
          C/ de las Huertas, 11
          <br />
          28012, Madrid
        </div>
        <a id="telMadrid" href="tel:911236249">
          911 23 62 49
        </a>
      </S.FooterItems>
    </S.ContactBlock>
  );
};

Offices.displayName = 'Offices';
export default Offices;
